@if (requiredError()) {
  <mat-error>
    {{ control.displayText }} <span i18n="@@isRequired">is required</span>
  </mat-error>
}
@if (minLengthError()) {
  <mat-error>
    {{ control.displayText }} <span i18n="@@minLength">must be at least</span>
    {{ control.strMinLength }} <span i18n="@@characters">characters</span>
  </mat-error>
}
@if (maxLengthError()) {
  <mat-error>
    {{ control.displayText }} <span i18n="@@maxLength">must be at most</span>
    {{ control.strMaxLength }} <span i18n="@@characters">characters</span>
  </mat-error>
}
@if (minError()) {
  <mat-error>
    {{ control.displayText }} <span i18n="@@minLength">must be at least</span>
    {{ control.minValue }}
  </mat-error>
}
@if (maxError()) {
  <mat-error>
    {{ control.displayText }} <span i18n="@@maxLength">must be at most</span>
    {{ control.maxValue }}
  </mat-error>
}
